/**
 * Resolves static asset paths dynamically using the configured BASE_URL.
 * This guarantees that assets are correctly located in both local development
 * environments and multi-site production/subsite deployments (e.g. Craft Cloud).
 */
export function resolveAsset(path) {
    if (!path) return '';
    let base = process.env.BASE_URL;
    if (base === 'undefined' || base === 'null' || !base) {
        base = '/';
    }
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    
    // Resolve relative to BASE_URL, collapsing multiple slashes
    let resolved = `${base}${cleanPath}`.replace(/\/\/+/g, '/');
    if (resolved.startsWith('undefined') || resolved.startsWith('/undefined') || resolved.startsWith('null') || resolved.startsWith('/null')) {
        resolved = resolved.replace(/^(?:\/?undefined|\/?null)/, '/');
    }
    return resolved;
}
